import { ajax } from '@/api/ajax';

export interface QueryByModelReq {
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 备件编码or名称
   */
  partNo?: string;
  /**
   * vin
   */
  vin?: string;
  /**
   * 只返回直送的备件：1-是，0-否
   */
  directPart?: number;
}

export interface QueryByModelResp {
  /**
   * 目录信息（主组-图例）
   */
  catalog?: Catalog[];
  /**
   * 备件列表
   */
  partList?: QueryByPartResp[];
  vehicleInfo?: VehicleInfo;
}
export interface Catalog {
  /**
   * 主组编码
   */
  groupCode?: string;
  /**
   * 主组名称
   */
  groupName?: string;
  /**
   * 图例列表
   */
  legendList?: Legend[];
}
export interface Legend {
  /**
   * 图例编码
   */
  legendCode?: string;
  /**
   * 图例名称
   */
  legendName?: string;
  /**
   * 图例SVG图片ID
   */
  legendSvgFileId?: string;
}
export interface QueryByPartResp {
  /**
   * 备件图片ID
   */
  partFileId?: string;
  /**
   * 备件名称
   */
  partName?: string;
  /**
   * 备件编码
   */
  partNo?: string;
  /**
   * 价格展示：0-隐藏，1-展示
   */
  priceDisplay?: number;
  /**
   * 销售价格
   */
  salePrice?: number;
  /**
   * 销售状态：0-停售 1-正常
   */
  saleState?: number;
  /**
   * 用法列表
   */
  usageList?: Usage[];
}
export interface Usage {
  /**
   * 品牌编码
   */
  brandCode?: string;
  /**
   * 品牌名称
   */
  brandName?: string;
  /**
   * 品牌排序
   */
  brandSort?: number;
  /**
   * 主组编码
   */
  groupCode?: string;
  /**
   * 主组名称
   */
  groupName?: string;
  /**
   * 主组排序
   */
  groupSort?: number;
  /**
   * 图例编码
   */
  legendCode?: string;
  /**
   * 图例名称
   */
  legendName?: string;
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 车型名称
   */
  modelName?: string;
  /**
   * 车型排序
   */
  modelSort?: number;
  /**
   * 车系编码
   */
  seriesCode?: string;
  /**
   * 车系名称
   */
  seriesName?: string;
  /**
   * 车系排序
   */
  seriesSort?: number;
}
/**
 * 车型信息
 */
export interface VehicleInfo {
  /**
   * 品牌编码
   */
  brandCode?: string;
  /**
   * 品牌名称
   */
  brandName?: string;
  /**
   * 内饰颜色
   */
  colorIn?: string;
  /**
   * 车身颜色
   */
  colorOut?: string;
  /**
   * 下线日期
   */
  manufactureTime?: string;
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 车型名称
   */
  modelName?: string;
  /**
   * 车系编码
   */
  seriesCode?: string;
  /**
   * 车系名称
   */
  seriesName?: string;
  /**
   * 车辆配置编码
   */
  sku?: string;
  /**
   * 车辆配置名称
   */
  skuName?: string;
  /**
   * 车架号
   */
  vin?: string;
}

/**
 * @operationId queryByModelUsingPOST
 * @tags EPC目录查询
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-epc-cn-boot/doc.html#/EPC-%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/EPC%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/queryByModelUsingPOST
 */
export function queryCataloglUsingPost(data: QueryByModelReq) {
  return ajax<QueryByModelResp>({
    url: '/api/tis/web/epc/catalog/query',
    method: 'post',
    data: data
  });
}
